import { useEffect } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const MyProfile = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Check auth immediately and redirect
        if (auth.currentUser) {
            navigate(`/profile/${auth.currentUser.uid}`, { replace: true });
            return;
        }
        
        const unsubAuth = onAuthStateChanged(auth, (u) => {
            if (!u) {
                navigate('/login');
                return;
            }
            navigate(`/profile/${u.uid}`, { replace: true });
        });
        return () => unsubAuth();
    }, [navigate]);

    // This component only redirects
    return null;
};

export default MyProfile;
